
const lastUpdate = '2026-03-15';
export const helpTitle = 'Lightning Explorer';

export const helpContent = `
<h1>${helpTitle}</h1>

<h2>Overview</h2>
<p>The Lightning Explorer displays current lightning strike data across the territory. Use it to identify recent strike activity and assess potential ignition risk.</p>

<h2>Data Columns</h2>
<ul>
  <li><strong>Strike Date</strong> — The date and time of the lightning strike.</li>
  <li><strong>Peak Current (kA)</strong> — The peak current of the strike in kiloamperes. Higher values indicate more energetic strikes.</li>
  <li><strong>Charge</strong> — Polarity of the strike: <strong>P</strong> (positive) or <strong>N</strong> (negative). Positive strikes are less common but typically more intense.</li>
  <li><strong>Multiplicity</strong> — The number of return strokes in the flash.</li>
</ul>

<h2>Filtering and Sorting</h2>
<ul>
  <li>Click any column header to sort by that column.</li>
  <li>Use the filter controls to narrow results by date range or other criteria.</li>
</ul>

<div class="last-update">Last Updated: ${lastUpdate}</div>
`;

export default helpContent;
